import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-triprequestscreen',
  templateUrl: './triprequestscreen.component.html',
  styleUrls: ['./triprequestscreen.component.css']
})
export class TriprequestscreenComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
